<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          title="CTQ Analyzer"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <v-form>
            <v-container py-0 class="mw-100">
              <v-layout wrap>
                <v-flex flex-small mt-3 xs12 sm6 lg1>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorMenu"
                    label="供應商"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex flex-small mt-3 xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryModel"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryModelMenu"
                    label="機種"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex flex-small mt-3 xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryPartNum"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryPartNumMenu"
                    label="料號（非必填）"
                    class="v-text-field__slot"
                    persistent-hint
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex flex-small mt-3 xs12 sm6 lg1>
                  <v-autocomplete
                    v-model="summaryProcess"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryProcessMenu"
                    label="製程別"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex flex-small mt-3 xs12 sm6 lg1>
                  <v-autocomplete
                    v-model="summaryStation"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryStationMenu"
                    label="位置"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex flex-small mt-3 xs12 sm6 lg1>
                  <v-autocomplete
                    v-model="summaryParameter"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryParameterMenu"
                    label="參數名稱"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex flex-small mt-3 xs12 sm6 lg1>
                  <v-autocomplete
                    v-model="summaryPeriodType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryPeriodTypeMenu"
                    label="週期"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex flex-small mt-3 xs12 lg2>
                  <v-menu
                    v-if="summaryPeriodType === 'day'"
                    v-model="summaryDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryDateStart"
                      :label="dateLabel"
                      prepend-icon="event"
                      readonly
                    />
                    <v-date-picker
                      v-model="summaryDateStart"
                      :min="'2025-01-01'"
                      :max="dayPickerMax"
                      :color="theme==='dark'?'danger':'general'"
                      :events="summaryDateList"
                      event-color="green"
                      no-title
                      scrollable
                    />
                  </v-menu>
                  <v-menu
                    v-else-if="summaryPeriodType === 'month'"
                    v-model="summaryMonthMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryMonthPicker"
                      :label="dateLabel"
                      prepend-icon="event"
                      readonly
                    />
                    <v-date-picker
                      v-model="summaryMonthPicker"
                      :min="'2025-01'"
                      :max="monthPickerMax"
                      :color="theme==='dark'?'danger':'general'"
                      :events="summaryDateList"
                      event-color="green"
                      type="month"
                      no-title
                      scrollable
                    />
                  </v-menu>
                  <v-autocomplete
                    v-else-if="summaryPeriodType === 'week'"
                    v-model="summaryDateStart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="contentDateList"
                    :label="dateLabel"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  >
                    <template v-slot:item="data">
                      <div
                        :class="{'weeks-list-data-tip':isPeriodHasData(data.item.value)}"
                        class="v-list__tile__content">
                        <div class="v-list__tile__title">
                          {{ data.item.text }}
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>分析
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        v-if="submit"
        flex_width_auto
        xs12>
        <material-card
          id="checkTable"
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          title="SPC-Chart"
          color="deep-orange"
          class="card-mix card-padding"
        >
        </material-card>
        <material-card
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          class="d-table-t0 no-data-left">
          <v-data-table
            :headers="responseHeaders"
            :items="responseData"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsAmount"
            class="freeze-title height-row-3"
            multi-sort
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr>
                <td class="table-width-120">{{ item.vendorCode || item.vendor }}</td>
                <td class="table-width-185">{{ item.partNumber }}</td>
                <td class="table-width-200" style="white-space: pre-line;">{{ item.modelName }}</td>
                <td class="table-width-100">{{ item.processName }}</td>
                <td class="table-width-120">{{ item.stationName }}</td>
                <td class="table-width-160">{{ item.testItemName || item.parameterName }}</td>
                <td class="table-width-150">{{ item.spec }}</td>
                <td class="table-width-90">{{ item.max }}</td>
                <td class="table-width-90">{{ item.min }}</td>
                <td class="table-width-90">{{ item.avg }}</td>
                <td class="table-width-90">{{ item.cpk }}</td>
                <td class="table-width-160">
                  <v-btn
                    class="mx-0 mr-3 font-weight-bold small"
                    color="orange"
                    @click="openctqplot(item)"
                  >
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>
                    正態分佈
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import qs from 'qs'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'PerformanceCTQAnalyzer',
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      submit: false,
      summaryVendor: '',
      summaryVendorMenu: [],
      summaryModel: '',
      summaryModelMenu: [],
      summaryPartNum: '',
      summaryPartNumMenu: [],
      summaryProcess: '',
      summaryProcessMenu: [],
      summaryStation: '',
      summaryStationMenu: [],
      summaryParameter: '',
      summaryParameterMenu: [],
      summaryPeriodType: 'day',
      summaryPeriodTypeMenu: [
        { text: '日', value: 'day' },
        { text: '周', value: 'week' },
        { text: '月', value: 'month' }
      ],
      summaryDateStart: '',
      summaryMonthMenu: false,
      summaryDateMenu: false,
      contentDateList: [],
      summaryDateList: [],
      responseData: [],
      rowsAmount: [25, 50, 100, { text: 'All', value: -1 }],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        sortBy: 'cpk',
        descending: true
      },
      responseHeaders: [
        { text: '供應商', value: 'vendorCode', class: 'table-width-120', sortable: true },
        { text: '料號', value: 'partNumber', class: 'table-width-185', sortable: true },
        { text: '機種', value: 'modelName', class: 'table-width-200', sortable: true },
        { text: '製程別', value: 'processName', class: 'table-width-100', sortable: true },
        { text: '位置', value: 'stationName', class: 'table-width-120', sortable: true },
        { text: '參數名稱', value: 'testItemName', class: 'table-width-160', sortable: true },
        { text: '標準', value: 'spec', class: 'table-width-150', sortable: true },
        { text: 'MAX', value: 'max', class: 'table-width-90', sortable: true },
        { text: 'Min', value: 'min', class: 'table-width-90', sortable: true },
        { text: 'Avg', value: 'avg', class: 'table-width-90', sortable: true },
        { text: 'CPK', value: 'cpk', class: 'table-width-90', sortable: true },
        { text: '', value: '', class: 'table-width-160', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    dateLabel () {
      if (this.summaryPeriodType === 'week') return '公司行事曆 WW'
      if (this.summaryPeriodType === 'month') return '月'
      if (this.summaryPeriodType === 'day') return '日'
      return '日期區間'
    },
    monthPickerMax () {
      const t = new Date()
      const m = t.getMonth() + 1
      return t.getFullYear() + '-' + (m < 10 ? '0' + m : String(m))
    },
    dayPickerMax () {
      return this.$moment(new Date()).format('YYYY-MM-DD')
    },
    summaryMonthPicker: {
      get () {
        const v = this.summaryDateStart
        const matched = String(v || '').match(/^(\d{4})M(\d{2})$/)
        return matched ? (matched[1] + '-' + matched[2]) : ''
      },
      set (val) {
        if (val && /^\d{4}-\d{2}$/.test(val)) {
          this.summaryDateStart = val.replace('-', 'M')
        } else {
          this.summaryDateStart = val || ''
        }
      }
    }
  },
  watch: {
    summaryVendor (val) {
      this.summaryModel = ''
      this.summaryPartNum = ''
      this.summaryModelMenu = []
      this.summaryPartNumMenu = []
      if (val && val !== 'All') this.loadModelMenu()
    },
    summaryModel (val) {
      this.summaryPartNum = ''
      this.summaryPartNumMenu = []
      if (this.summaryVendor && this.summaryVendor !== 'All' && val) this.loadPartNumMenu()
    },
    summaryProcess (val) {
      this.summaryStation = ''
      this.summaryParameter = ''
      this.summaryParameterMenu = []
      if (!val) {
        this.summaryStationMenu = []
        return
      }
      this.loadStationMenu()
    },
    summaryStation (val) {
      this.summaryParameter = ''
      if (!val) {
        this.summaryParameterMenu = []
        return
      }
      this.loadParameterMenu()
    },
    summaryMonthPicker () {
      this.summaryMonthMenu = false
    },
    summaryDateStart (val) {
      if (this.summaryPeriodType === 'day' && val) {
        this.summaryDateMenu = false
      }
    },
    summaryPeriodType () {
      this.buildDateList()
      this.loadTimePeriod()
    },
    summaryParameter () {
      this.loadTimePeriod()
    },
    summaryPartNum () {
      this.loadTimePeriod()
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctqThermalPerformance/CTQAnalyzer')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          const body = {
            type: 'thermal_module'
          }
          this.$http.get('/api/system/pmsPath/getCodeAndNameListByType?' + qs.stringify(body)).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                const data = res.data
                this.summaryVendorMenu = [
                  { text: 'All', value: 'All' },
                  ...data.map(item => ({
                    text: item.code,
                    value: item.code
                  }))
                ]

                // if (this.tempFactory !== '') {
                //   this.summaryVendor = this.tempFactory
                // }
              }
            })
          this.loadProcessMenu()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    mapOptions (list, textKey, valueKey) {
      return (list || []).map(item => ({
        text: item[textKey],
        value: item[valueKey]
      }))
    },
    loadModelMenu () {
      const body = { vendorCode: this.summaryVendor }
      this.$http.get('/api/thermalModule/ctq/selectOption/modelName?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryModelMenu = this.mapOptions(res.data, 'modelName', 'modelName')
          }
        })
    },
    loadPartNumMenu () {
      const body = {
        vendorCode: this.summaryVendor,
        modelName: this.summaryModel
      }
      this.$http.get('/api/thermalModule/ctq/selectOption/partNumber?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryPartNumMenu = this.mapOptions(res.data, 'partNumber', 'partNumber')
          }
        })
    },
    loadProcessMenu () {
      this.$http.get('/api/thermalModule/ctq/selectOption/process').then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryProcessMenu = this.mapOptions(res.data, 'processName', 'processCode')
          }
        })
    },
    loadStationMenu () {
      const body = { processCode: this.summaryProcess }
      this.$http.get('/api/thermalModule/ctq/selectOption/station?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryStationMenu = this.mapOptions(res.data, 'stationName', 'stationCode')
          }
        })
    },
    loadParameterMenu () {
      const body = {
        processCode: this.summaryProcess,
        stationCode: this.summaryStation
      }
      this.$http.get('/api/thermalModule/ctq/selectOption/testItem?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryParameterMenu = this.mapOptions(res.data, 'testItemName', 'testItemCode')
          }
        })
    },
    normalizeWeekKey (value) {
      const s = String(value || '')
      const shortYear = s.match(/^(\d{2})W(\d{1,2})$/i)
      if (shortYear) return '20' + shortYear[1] + 'W' + this.pad(Number(shortYear[2]))
      const fullYear = s.match(/^(\d{4})W(\d{1,2})$/i)
      if (fullYear) return fullYear[1] + 'W' + this.pad(Number(fullYear[2]))
      return s
    },
    normalizeMonthKey (value) {
      const s = String(value || '')
      const compact = s.match(/^(\d{4})(\d{2})$/)
      if (compact) return compact[1] + '-' + compact[2]
      const dotted = s.match(/^(\d{4})[-M](\d{2})$/i)
      if (dotted) return dotted[1] + '-' + dotted[2]
      return s
    },
    normalizeTimePeriod (list, timeType) {
      return (list || []).map((item) => {
        const raw = String(item)
        if (timeType === 'week') return this.normalizeWeekKey(raw)
        if (timeType === 'month') return this.normalizeMonthKey(raw)
        return raw.substr(0, 10)
      }).filter(Boolean)
    },
    isPeriodHasData (value) {
      if (!value) return false
      const key = this.summaryPeriodType === 'week'
        ? this.normalizeWeekKey(value)
        : this.summaryPeriodType === 'month'
          ? this.normalizeMonthKey(value)
          : String(value)
      return this.summaryDateList.indexOf(key) !== -1
    },
    loadTimePeriod () {
      if (!this.summaryVendor || this.summaryVendor === 'All' ||
          !this.summaryModel || !this.summaryProcess ||
          !this.summaryParameter || !this.summaryPeriodType) {
        this.summaryDateList = []
        return
      }
      const body = {
        vendorCode: this.summaryVendor,
        modelName: this.summaryModel,
        testItemCode: this.summaryParameter,
        processCode: this.summaryProcess,
        timeType: this.summaryPeriodType
      }
      if (this.summaryPartNum && this.summaryPartNum !== 'All') {
        body.partNumber = this.summaryPartNum
      }
      console.info(body)
      this.$http.get('/api/thermalModule/ctq/selectOption/timePeriod?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            this.summaryDateList = this.normalizeTimePeriod(res.data, this.summaryPeriodType)
          }
        })
    },
    queryTimeRange () {
      const type = this.summaryPeriodType
      const value = this.summaryDateStart
      if (!type || !value) return { startTime: '', endTime: '' }
      if (type === 'day') {
        const day = String(value).substr(0, 10)
        return { startTime: day, endTime: day }
      }
      if (type === 'week') {
        const matched = String(value).match(/^(\d{4})W(\d{1,2})$/i)
        if (matched && this.$moment) {
          const start = this.$moment()
            .isoWeekYear(Number(matched[1]))
            .isoWeek(Number(matched[2]))
            .startOf('isoWeek')
          const end = start.clone().endOf('isoWeek')
          return {
            startTime: start.format('YYYY-MM-DD'),
            endTime: end.format('YYYY-MM-DD')
          }
        }
        const weekItem = this.contentDateList.find(e => e.value === value)
        const range = weekItem && String(weekItem.text).match(/\((\d{2}-\d{2})\s*~\s*(\d{2}-\d{2})\)/)
        if (range) {
          const year = String(value).substr(0, 4)
          return {
            startTime: year + '-' + range[1],
            endTime: year + '-' + range[2]
          }
        }
        return { startTime: '', endTime: '' }
      }
      const month = String(value).match(/^(\d{4})M(\d{2})$/)
      if (month && this.$moment) {
        const start = this.$moment(month[1] + '-' + month[2] + '-01')
        return {
          startTime: start.format('YYYY-MM-DD'),
          endTime: start.clone().endOf('month').format('YYYY-MM-DD')
        }
      }
      return { startTime: '', endTime: '' }
    },
    mapStatisticRow (row) {
      return Object.assign({}, row, {
        vendor: row.vendorCode || row.vendor,
        parameterName: row.testItemName || row.parameterName
      })
    },
    pad (n) {
      return String(n).padStart(2, '0')
    },
    buildDateList () {
      const val = this.summaryPeriodType
      const result = []
      const today = new Date()
      const currentYear = today.getFullYear()
      const startYear = 2025
      const pad = this.pad

      if (val === 'day') {
        const cursor = new Date(today)
        for (let i = 0; i < 90; i++) {
          const y = cursor.getFullYear()
          const m = pad(cursor.getMonth() + 1)
          const d = pad(cursor.getDate())
          const v = `${y}-${m}-${d}`
          result.push({ text: v, value: v })
          cursor.setDate(cursor.getDate() - 1)
        }
      }

      if (val === 'month') {
        for (let y = currentYear; y >= startYear; y--) {
          let maxMonth = 12
          if (y === currentYear) maxMonth = today.getMonth() + 1
          for (let m = maxMonth; m >= 1; m--) {
            result.push({
              text: `${y}-${pad(m)}`,
              value: `${y}M${pad(m)}`
            })
          }
        }
      }

      if (val === 'week') {
        const format = (d) => `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
        const getWeekStart = (date) => {
          const d = new Date(date)
          const day = d.getDay() || 7
          if (day !== 1) d.setDate(d.getDate() - day + 1)
          d.setHours(0, 0, 0, 0)
          return d
        }
        const getWeekEnd = (start) => {
          const end = new Date(start)
          end.setDate(start.getDate() + 6)
          return end
        }
        let cursor = getWeekStart(new Date(startYear, 0, 1))
        for (; cursor <= today;) {
          const start = new Date(cursor)
          const end = getWeekEnd(start)
          const isoYear = this.$moment(start).isoWeekYear()
          const weekNo = this.$moment(start).isoWeek()
          result.push({
            text: `${isoYear} W${pad(weekNo)} (${format(start)} ~ ${format(end)})`,
            value: `${isoYear}W${pad(weekNo)}`
          })
          cursor = new Date(cursor)
          cursor.setDate(cursor.getDate() + 7)
        }
        result.reverse()
      }

      this.contentDateList = result
      this.summaryDateStart = ''
    },
    doSubmitVerification () {
      if (!this.summaryVendor) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇供應商'
        return false
      }
      if (!this.summaryModel) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇機種'
        return false
      }
      if (!this.summaryProcess) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇製程別'
        return false
      }
      if (!this.summaryStation) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇位置'
        return false
      }
      if (!this.summaryParameter) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇參數名稱'
        return false
      }
      if (!this.summaryPeriodType) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇週期'
        return false
      }
      if (!this.summaryDateStart) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇日期區間'
        return false
      }
      return true
    },
    doSubmit () {
      if (!this.doSubmitVerification()) return
      const range = this.queryTimeRange()
      if (!range.startTime || !range.endTime) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '無法解析查詢區間'
        return
      }
      const body = {
        vendorCode: this.summaryVendor,
        modelName: this.summaryModel,
        processCode: this.summaryProcess,
        testItemCode: this.summaryParameter,
        startTime: range.startTime,
        endTime: range.endTime
      }
      if (this.summaryPartNum && this.summaryPartNum !== 'All') {
        body.partNumber = this.summaryPartNum
      }
      this.loadingView = true
      this.$http.get('/api/thermalModule/ctq/dataStatistic?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          console.info(res)
          this.loadingView = false
          this.submit = true
          if (res.status === 'success') {
            this.responseData = (res.data || []).map(this.mapStatisticRow)
            if (!this.responseData.length) {
              this.snackbar = true
              this.snackbarColor = 'orange'
              this.snackbarMsg = '查無資料'
            }
          } else {
            this.responseData = []
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = res.errMsg || '查詢失敗'
          }
        })
        .catch(() => {
          this.loadingView = false
          this.snackbar = true
          this.snackbarColor = 'red'
          this.snackbarMsg = '查詢失敗'
        })
    },
    weeklyExportFileName (date) {
      let year = ''
      let week = ''
      const weekMatch = String(this.summaryDateStart || '').match(/^(\d{4})W(\d{1,2})$/i)
      if (weekMatch) {
        year = weekMatch[1]
        week = this.pad(weekMatch[2])
      } else if (date && this.$moment) {
        const m = this.$moment(date)
        year = String(m.isoWeekYear())
        week = this.pad(m.isoWeek())
      }
      const sent = this.$moment ? this.$moment().format('YYYYMMDDHHmmss') : ''
      return year + 'W' + week + '_Weekly_CTQ_thermal_report_' + sent + '.xlsx'
    },
    selectedText (menu, value) {
      const found = (menu || []).find(e => e.value === value)
      return found ? found.text : value
    },
    baseItemName (item) {
      return String(item.testItemName || item.parameterName || '')
        .replace(/（最小值）/g, '')
        .replace(/（最大值）/g, '')
        .replace(/\(最小值\)/g, '')
        .replace(/\(最大值\)/g, '')
    },
    plotItemType (item) {
      const name = String(item.testItemName || item.parameterName || '')
      if (name.indexOf('最小值') !== -1) return 5
      if (name.indexOf('最大值') !== -1) return 6
      return 4
    },
    samePlotGroup (a, b) {
      return (a.vendorCode || a.vendor) === (b.vendorCode || b.vendor) &&
        a.partNumber === b.partNumber &&
        a.modelName === b.modelName &&
        a.processName === b.processName &&
        a.stationName === b.stationName &&
        this.baseItemName(a) === this.baseItemName(b)
    },
    openctqplot (item) {
      const range = this.queryTimeRange()
      const related = (this.responseData || []).filter(row => this.samePlotGroup(row, item))
      const rows = (related.length ? related : [item]).slice()
      rows.sort((a, b) => this.plotItemType(a) - this.plotItemType(b))
      const searchdate = range.startTime && range.endTime
        ? (range.startTime === range.endTime ? range.startTime : (range.startTime + ' ~ ' + range.endTime))
        : this.summaryDateStart
      const body = {
        vendorCode: this.summaryVendor,
        factoryName: this.summaryVendor,
        partNumber: item.partNumber || this.summaryPartNum,
        processCode: this.summaryProcess,
        process: this.selectedText(this.summaryProcessMenu, this.summaryProcess) || item.processName,
        stationCode: this.summaryStation,
        station: this.selectedText(this.summaryStationMenu, this.summaryStation) || item.stationName,
        testItemCode: this.summaryParameter,
        parametername: this.selectedText(this.summaryParameterMenu, this.summaryParameter) || this.baseItemName(item),
        statisticTimeType: this.summaryPeriodType,
        periodtype: (this.summaryPeriodTypeMenu.find(e => e.value === this.summaryPeriodType) || {}).text,
        statisticTimeValue: this.summaryDateStart,
        searchdate,
        project: item.modelName,
        responseData: rows
      }
      localStorage.setItem('ctqPerfFilterInfo', JSON.stringify(body))
      sessionStorage.removeItem('cachePerfFilterInfo')
      const routeData = this.$router.resolve({
        path: '/ctqThermalPerformance/CTQAnalyzer/ShowCTQNormaldistributionplot',
        query: {
          statisticTestItemType: this.plotItemType(item)
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style>
.text-center {
  text-align: center !important;
}
</style>
